import { render, staticRenderFns } from "./RevokeCertificate.vue?vue&type=template&id=7fbc8a9e"
import script from "./RevokeCertificate.vue?vue&type=script&lang=ts"
export * from "./RevokeCertificate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/azureuser/myagent/_work/5/s/apps/front/flightpath-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fbc8a9e')) {
      api.createRecord('7fbc8a9e', component.options)
    } else {
      api.reload('7fbc8a9e', component.options)
    }
    module.hot.accept("./RevokeCertificate.vue?vue&type=template&id=7fbc8a9e", function () {
      api.rerender('7fbc8a9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/RevokeCertificate.vue"
export default component.exports